import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type CloneCourseRevisionResponse = {
  id: string;
  name: string;
  slug: string;
  description: string;
  part: string;
  InstructorId: string;
  img_url: string;
  num_hours: string;
  actualPrice_egp: string;
  actualPrice_usd: string;
  discountPrice_egp: string | null;
  discountPrice_usd: string | null;
  discountPercentage: string | null;
  preview_video: string;
  isTrending: boolean;
  borchure_url: string;
  createdAt: string;
  updatedAt: string;
  categoryId: string;
  parentCourseId: string;
  packageId: string | null;
} & ApiError;
export const CloneCourseRevision = (
  courseId: string
): Promise<CloneCourseRevisionResponse> => {
  return axios.post(`/course/replicate/${courseId}`);
};
